import Markdown from 'markdown-to-jsx';
import * as React from 'react';

import BulbIcon from '../../assets/icons/Bulb';
import { ChatMessageTypes, ChatMessageTypesClassMap } from '../../store';

export const dataTestId = `${
	ChatMessageTypesClassMap[ChatMessageTypes.Tip]
}-message`;

export const TipMessage: React.FC = ({ children }) => {
	return (
		<div
			data-testid={dataTestId}
			className="chat-tip border-gray-40 flex px-3 py-2 mx-2 mb-2 bg-white border border-solid rounded-md"
		>
			<div>
				{/* Max width is necessary to fix an IE11 bug which makes the SVG too wide compared to the text */}
				<div style={{ maxWidth: '22px' }}>
					<BulbIcon
						className="c-icon text-ongreen"
						style={{ fontSize: '22px' }}
					/>
				</div>
			</div>
			<div className="text-body-sm flex-grow pl-2">
				{typeof children === 'string' ? (
					<Markdown>{children}</Markdown>
				) : (
					<React.Fragment>{children}</React.Fragment>
				)}
			</div>
		</div>
	);
};

export default TipMessage;
